var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTransfers = function SvgIconTransfers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3984 81.5616L72.8473 89.6291L76.4516 93.5555L92 78.8795L76.4516 64.2035L72.8473 68.13L81.3984 76.1975H34.4257C28.2845 76.1975 23.285 71.1231 23.285 64.8901L23.2955 49.7743H18V64.8901C18 74.0841 25.3672 81.5616 34.4257 81.5616H81.3984Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6016 27.4384L37.1527 19.3709L33.5483 15.4444L18 30.1204L33.5483 44.7965L37.1527 40.87L28.6016 32.8025H75.5638C81.7049 32.8025 86.7045 37.8768 86.7045 44.1099V59.2257H92V44.1099C92 34.9159 84.6328 27.4384 75.5743 27.4384H28.6016Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTransfers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-transfers.cd0f9bbf.svg";
export { ForwardRef as ReactComponent };